import React, { Component } from 'react';
import { render } from 'react-dom';
import VASSlider from 'react-surveyjs-vas-widget';
// import { Survey, CustomWidgetCollection } from 'survey-react';
import * as Survey from "survey-react";
import   SideNav from "./../../component/sidenav/sidenav.js"
import  AuthService  from "../api/authentication.js";
import Slider from "react-slick";
import axios from 'axios';
import _  from 'underscore';
import "survey-react/survey.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import   Photo from "./photos"
import { Link, DirectLink, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import "./profile.css"


var dataE = [
  "1 -- 10",
  "1 -- 50",
  "1 -- 100",
  "1 -- 200",
  "1 -- 300",
  "1 -- 400",
  "1 -- 500",
]



const Auth = new AuthService();
class Profile extends Component {


  constructor(props){
    super(props)
    this.state = {
        noerorrpage :  true,
        Employees : [],
        type:[],
        shoeedit:false,
        photos : [],
        images: [],
        imageUrls : [],
        details:[],
        ifImage :false,
        Imgprofile:false,
        logoPro:false,
        certificat : false,
        logoProImg:"",
        certificatImg:[],
        ImgprofileIme:[],
        categoeris:[],
        category:[],
        
        getCategory:"",
        domain: 'https://uvune-listing.herokuapp.com',
        user:"",
        loanData : true
        // description: this.props.organizer.description
     };

     
     
    
    }


    componentWillReceiveProps(nextProps) {
		

      if (nextProps.organizer) {
        console.log("new org------->",nextProps.organizer.company_images_url)
       
        this.setState({
          // isAuthenticated: nextProps.isAuthenticated,
          organizer: nextProps.organizer,
           ImgprofileIme:nextProps.organizer.company_images_url,
           certificatImg:nextProps.organizer.certifications_images_url
       
        });
      
        // this.getDashboardDatas(nextProps.user);
        this.getCategoryPro(nextProps.organizer.category);
        Events.scrollEvent.register('begin', function () {
          // console.log("begin", arguments);
        });
    
        Events.scrollEvent.register('end', function () {
          // console.log("end", arguments);
        });
    
      }
    }


    
// componentWillReceiveProps(nextProps) {
		
// console.log("new org------->",nextProps.organizer.company_images_url)
//   if (nextProps.organizer) {

//     this.setState({
//       // isAuthenticated: nextProps.isAuthenticated,
//       ImgprofileIme:nextProps.organizer.company_images_url
//       // product: nextProps.o,       
//     });
  
//     // this.getDashboardDatas(nextProps.user);
//     // this.GetCategory(nextProps.organizer.category);
//   }
// }

    
componentDidMount(){
    this.props.noerorrpage(this.state.noerorrpage)
    this.setState ({
      Employees: dataE,
  }) 
  


 
  // this.setState({
  //   activitiesIsLoading: true
  // });

  if (this.props.user) {
    // this.getDashboardDatas(this.props.user);
  } else {
    this.setState({
      isLoading: true
    });
  }
  
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
    //  body: JSON.stringify(data),
  };

  fetch(this.state.domain+"/category?$limit=40", requestOptions )
  .then(res => res.json())
  .then(res => {
        // console.log("error state this.state. getreview==----===----> ", res )
          this.setState({
            categoeris : res.data,
            // getfirstCate : res.data[0],
            loanData : false,
            product:res
          })  
    
  })

    
}

scrollToTop() {
  scroll.scrollToTop();
}
scrollTo() {
  scroller.scrollTo('scroll-to-element', {
    duration: 800,
    delay: 0,
    smooth: 'easeInOutQuart'
  })
}
scrollToWithContainer() {

  let goToContainer = new Promise((resolve, reject) => {

    Events.scrollEvent.register('end', () => {
      resolve();
      Events.scrollEvent.remove('end');
    });

    scroller.scrollTo('scroll-container', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart'
    });

  });

  goToContainer.then(() =>
    scroller.scrollTo('scroll-container-second-element', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      containerId: 'scroll-container'
    }));
}
componentWillUnmount() {
  Events.scrollEvent.remove('begin');
  Events.scrollEvent.remove('end');
}

getCategoryPro = (data)=>{

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
    //  body: JSON.stringify(data),
  };

  fetch(this.state.domain+"/category/" + data, requestOptions )
  .then(res => res.json())
  .then(res => {
        // console.log("get category id==----===----> ", res )
          this.setState({
     
            getfirstCate : res,
            getCategory : res._id
          })  
    
  })
}

editClose=(e)=>{
  e.preventDefault()
  this.setState({
    shoeedit:false
  })
}


editShow=(e)=>{
  e.preventDefault()
  this.setState({
    shoeedit:true
  })
  // console.log("-----------------=0-> yes")
}



selectImages = (event) => {
  event.preventDefault();
let images = []
let photos  = []
 for (var i = 0; i <  event.target.files.length && i < 1 ; i++) {
    images[i] = event.target.files.item(i);
    photos[i] =  URL.createObjectURL(event.target.files.item(i))

 }


if(event.target.files.length  !== 0){
 this.setState({
   ifImage :true,
   editImage :true
 })
}else{
  this.setState({
    ifImage :false
  })
}
//  console.log("iamge -------->rt", images)
if(images.filter(image => image.name.match(/\.(jpg|jpeg|png|gif|pdf)$/))){
//  console.log("yes------------->")
  this.setState({ 
    images:images, 
    // message :message,
     photos
    })
   
}else{
  // console.log("no------------->")
  toast("Image only jpg | jpeg | png | gif");
}
// images = images.filter(image => image.name.match(/\.(jpg|jpeg|png|gif|pdf)$/))
// let message = `${images.length} valid image(s) selected`

}


uploadImages=(event) => {
 
  event.preventDefault();
  this.setState({
    loanData:true
  })
    
  // console.log('done image----> 1', this.state.images);

   const uploaders = this.state.images.map(image => {
    // console.log('done image----> 4', );
        const formData = new FormData();
        //  console.log('done image---->', image );
        if(this.state.Imgprofile){
          formData.append('uri', image, image.name);
          formData.append('company_images', true);
          formData.append('company_id',  this.props.user.company_id);
          // console.log('done image---->', image );
        }else if(this.state.logoPro){
          formData.append('uri', image, image.name);
          formData.append('company_logo', true);
          formData.append('company_id',  this.props.user.company_id);
          // console.log('done image---->2', image );
        }else if(this.state.certificat){
          formData.append('uri', image, image.name);
          formData.append('certifications_images', true);
          formData.append('company_id',  this.props.user.company_id);
          // console.log('done image---->3', image );
        }else{
          formData.append('uri', image, image.name);
          // console.log('done image---->1', image );
          formData.append('company_images', true);
          formData.append('company_id',  this.props.user.company_id);

        }
        
        const options = {
            method: 'POST',
            headers: { 
                'content-type': 'multipart/form-data',
            'access-control-allow-origin': '*',
            'Authorization': Auth.getToken(), 
            },
            url:this.state.domain+"/upload-logo",
     };

//  console.log('done image---->1',  options );
   // Make an AJAX upload request using Axios
   return  axios.post(options.url, formData, options.headers)
   .then(response => {
          // console.log("response", response.data)
         if(this.state.Imgprofile){
          //  console.log("this.state.Imgprofile --->", response)
           const  ImgprofileIme = this.props.organizer.company_images_url
          //  console.log("ImgprofileIge is  --->",  ImgprofileIme,   response.data.uri)
             ImgprofileIme.push(
                      response.data.uri
                  )
              this.setState({
                ImgprofileIme: ImgprofileIme,
              })
        }else if(this.state.logoPro){
          //  console.log("this.state.logoPro --->", response.data)
          this.setState({
            logoProImg:  response.data.uri
          })
        }else if(this.state.certificat){
          const  certificatImg = this.props.organizer.certifications_images_url
        //  console.log("ImgprofileIge is  --->",  certificatImg,   response.data.uri)
          certificatImg.push(
                     response.data.uri
                 )
             this.setState({
              certificatImg:certificatImg,
             })
        }else{
        

        }
         this.setState({
           imageUrls: [response.data.result, ...this.state.imageUrls ]
           });
         
       })
      
 });
 
   // Once all the files are uploaded 
     axios.all(uploaders).then(() => {
      //  this.forceUpdate(this.state.imageUrls)
          // console.log('done');
          this.setState({
            loanData:false,
            shoeedit:false
          })
     }).catch(err => alert(err.message));



}


upDate_data = (e)=>{
  e.preventDefault()
  // console.log("data update===----->", this.state.select)
//  if(this.state. submitIftrue){
  this.setState({
    loanData:true
  })
   const data = {
      official_name : this.name.value,
      established :this.established.value,
      business_email :this.email.value,
      business_mobile:this.business_mobile.value,
      location_state : this.state1.value,
      location_city: this.city.value,
      category :this.state.getCategory,
       total_employees : this.state.select,
       main_products: this.mainproduct.value
    
   }

   const requestOptionsUser = {
    method: 'PATCH', 
    headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
    body: JSON.stringify(data),
};
    // console.log("data update", data, requestOptionsUser, this.props.user.company_id)
   
          //    console.log("data update", requestOptions, this.props.user. _id)
             fetch(this.state.domain+"/companies/"+ this.props.user.company_id, requestOptionsUser)
             .then(res => res.json())
             .then((res)=>{
                 if(res){

                    // console.log("result", res)
                    toast("Updated !");
                     this.setState({
                         loading:false,
                         loanData:false
                     })
                     
                    //  this.props.history.replace('/dashboard');
                 }
               
             }).catch( (error) => {
              
        })
   
}

profileImage=(e)=>{
   e.preventDefault
   this.setState({
    logoPro:false,
    certificat:false,
    Imgprofile:true,
     photos : []
   })
  
}



profileLogo=(e)=>{
  e.preventDefault
 
    this.setState({
      Imgprofile:false,
      certificat:false,
      photos : [],
      logoPro:true
     })
}

certifications=(e)=>{
  e.preventDefault
 
    this.setState({
      Imgprofile:false,
      logoPro:false,
      certificat:true
     })
  
}

deletePhoto = (data) =>{
  // console.log("data--===------> i", data, this.state. ImgprofileIme)
                           
  
  if(this.state.Imgprofile){
    const fitleredmeassages = this.state.ImgprofileIme.filter(( meassage ,i) =>{
    //  console.log("conselo==------> ooo",i)
      return i !== data
    })
      // this.setState({images:fitleredmeassages})

      // this.setState({
      //   loanData : true,
      //   ifSubmit : true,
      //   loadingButton: true  
      // }) 
      
       const data1 ={
        
        company_images_url:fitleredmeassages
 
       }
      
       const requestOptions = {
           method: 'PATCH', 
           headers: {'Content-Type':'application/json', 'Access-Control-Allow-Origin': '*',    'Authorization': Auth.getToken(),  },
            body: JSON.stringify(data1),
       };
      //  console.log(" requestOptions",  requestOptions)
       fetch(this.state.domain+"/companies/"+ this.props.user.company_id, requestOptions)
       .then(res => res.json())
       .then((res)=>{
            //  console.log("data, rest--==--->", res)
           if(res.code === 400 || res.code  === 500){
               
               }else{
               
                 if(res.company_images_url.length === 0) {
                  this.setState({
                    ifSubmit : false,
                    ifImage:false,
                    showeditPage:false,
                    loanData : false,
                    //  images: res.product_images_url
                  })
                 }else{
                  this.setState({
                    // ifImage:false,
                    ImgprofileIme:fitleredmeassages
                  
                  })
                  toast("Photo deleted !");
                }
                   
             }
             
      })
   
  }else if(this.state.certificat){
        const fitleredmeassages = this.state.certificatImg.filter(( meassage ,i) =>{
          // console.log("conselo==------> ooo",i)
          return i !== data
        })
    
          const data1 ={
            
            certifications_images_url:fitleredmeassages
    
          }
          
          const requestOptions = {
              method: 'PATCH', 
              headers: {'Content-Type':'application/json', 'Access-Control-Allow-Origin': '*',    'Authorization': Auth.getToken(),  },
                body: JSON.stringify(data1),
          };
          // console.log(" requestOptions",  requestOptions)
          fetch(this.state.domain+"/companies/"+ this.props.user.company_id, requestOptions)
          .then(res => res.json())
          .then((res)=>{
                // console.log("data, rest--==--->", res)
              if(res.code === 400|| res.code  === 500){
                  
                  }else{
                  
                    if(res.certifications_images_url.length === 0) {
                      this.setState({
                        ifSubmit : false,
                        ifImage:false,
                        showeditPage:false,
                        loanData : false,
                        //  images: res.product_images_url
                      })
                    }else{
                      this.setState({
                        // ifImage:false,
                        certificatImg:fitleredmeassages
                      
                      })
                      toast("Photo deleted !");
                    }
                      
                }
                
          })

 
  }else{
   
  }
    // console.log("data,----->update ",fitleredmeassages.length)
    //  this.setState({images:fitleredmeassages})

    //   this.setState({
    //     loanData : true,
    //     ifSubmit : true,
    //     loadingButton: true  
    //   }) 
      
    //    const data1 ={
        
    //     product_images_url:fitleredmeassages
 
    //    }
      
    //    const requestOptions = {
    //        method: 'PATCH', 
    //        headers: {'Content-Type':'application/json', 'Access-Control-Allow-Origin': '*',    'Authorization': Auth.getToken(),  },
    //         body: JSON.stringify(data1),
    //    };
      //  console.log(" requestOptions",  requestOptions)
      //  fetch(this.state.domain+"/products/"+ this.state.id, requestOptions)
      //  .then(res => res.json())
      //  .then((res)=>{
      //       // console.log("data, rest--==--->", res)
      //      if(res.code === "400" || res.code  === "500"){
               
      //          }else{
      //            toast("Photo deleted !");
      //            if(res.product_images_url.length === 0) {
      //             this.setState({
      //               ifSubmit : false,
      //               ifImage:false,
      //               showeditPage:false,
      //               loanData : false,
      //               //  images: res.product_images_url
      //             })
      //            }else{
      //             this.setState({
      //               // ifImage:false,
      //               showeditPage:false,
      //               loanData : false,
                  
      //             })
      //            }
                   
      //        }
             
      // })
  

}

selectChange = (e)=>{
  this.setState({
      select: e.target.value
    })
  //  console.log("data--===------> contry", e.target.value)
}

selectCategory = (e)=>{
  // console.log("data--===------> category", e.target.value)
  this.setState({
    getCategory: e.target.value
  })

}

selectChangeC = (e)=>{
this.setState({
    selectC: e.target.value
  })
//  console.log("data--===------> contry", e.target.value)
}

toggleState=()=> {
  this.setState({
    toggle: !this.state.toggle
  });
}







  render() {
    

    const styles = {
      fontFamily: 'sans-serif',
      textAlign: 'center',
    };
    
    const settings = {
      // dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />
    };
    // console.log("data,file","props", this.state.organizer)
    // console.log("this.state.logoPro --->", this.state.ImgprofileIme)
    return (
          !this.props.isAuthenticated ? (
            <div className="hero is-bold is-fullheight">
            <div className="level-item">
              <a className="button is-loading is-large is-light">Loading</a>
            </div>
            <div className="level-item">
              <span>Trying to login...</span>
            </div>
          </div>
            ) : 
              <div id="dashboard-wrapper " class="columns dashboard-cousom">
                <ToastContainer />
                 {this.state.loanData?
                //   <Leader/>
                    <div class="pre-loader">
                  <div class="loader"></div>
                </div> 
                      :
                      <div></div>
               }
              <div class="column"></div>
              <div class="content column is-11">
          
                  {/* <!-- Breadcrumbs --> */}
                  <nav class="breadcrumbs">
                      {/* <button onClick={this.clickeme}>click</button> */}
                      <ul>
                          <li><a href="/">Home</a></li>
                          <li>Company Profile</li>
                      </ul>
                  </nav>
                  {/* <!-- /Breadcrumbs -->
          
                  <!-- Dashboard Wrapper --> */}
                     <div class="dashboard-wrapper"> 
                        <div className="profile-comapny-setting">
                        {/* {
                            this.state.shoeedit ? 
                              "Add file"
                              :
                              <i class="fas fa-times"></i>
                          } */}
                          
                     
                        <br/>
                        <br/>
                            <div className="profile-gallary-body">
                                      {/* <nav className="navbar navbar-default navbar-fixed-top">
                                          <div className="container-fluid">
                                            <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                                              <ul className="nav navbar-nav">
                                                <li><Link activeClass="active" className="test1" to="test1" spy={true} smooth={true} duration={500} >Test 1</Link></li>
                                                <li><Link activeClass="active" className="test2" to="test2" spy={true} smooth={true} duration={500}>Test 2</Link></li>
                                                <li><Link activeClass="active" className="test3" to="test3" spy={true} smooth={true} duration={500} >Test 3</Link></li>
                                                <li><Link activeClass="active" className="test4" to="test4" spy={true} smooth={true} duration={500}>Test 4</Link></li>
                                                <li><Link activeClass="active" className="test5" to="test5" spy={true} smooth={true} duration={500} delay={1000}>Test 5 ( delay )</Link></li>
                                                <li><Link activeClass="active" className="test6" to="anchor" spy={true} smooth={true} duration={500}>Test 6 (anchor)</Link></li>
                                                <li> <a onClick={() => scroll.scrollTo(100)}>Scroll To 100!</a></li>
                                                <li> <a onClick={() => scroll.scrollToBottom()}>Scroll To Bottom</a></li>
                                                <li> <a onClick={() => scroll.scrollMore(500)}>Scroll 500 More!</a></li>
                                                <li> <a onClick={() => scroll.scrollMore(1000, { delay: 1500 })}>Scroll 1000 More! ( delay ) </a></li>
                                                <li><Link activeClass="active" className="test8" to="same" spy={true} smooth={true} duration={500}>Same target</Link></li>
                                                <li><Link activeClass="active" className="test9" to="same" spy={true} smooth={true} duration={500}>Same target</Link></li>
                                                <li><a className="test1" to="test1" onClick={() => this.scrollTo()} >Scroll to element</a></li>
                                                <li><a className="test1" to="test1" onClick={() => this.scrollToWithContainer()} >Scroll to element within container</a></li>
                                              </ul>
                                            </div>
                                          </div>
                                        </nav>

                                        <Element name="test1" className="element" >
                                          test 1
                                      </Element>

                                        <Element name="test2" className="element">
                                          test 2
                                      </Element>

                                        <Element name="test3" className="element">
                                          test 3
                                      </Element>

                                        <Element name="test4" className="element">
                                          test 4
                                      </Element>

                                      <div id="anchor" className="element">
                                  test 6 (anchor)
                              </div>
                                        <Element name="test5" className="element">
                                          test 5
                                      </Element> */}
                            {/* <button onClick={this.handleOnClick}>Click me</button> */}
         
                                  <div className={ this.state.Imgprofile ? "profile-gallary-header-ative" : "profile-gallary-header" }>
                                   <a onClick={this.profileImage}><p><b>Company Gallery  <i class="far fa-images"></i></b></p> </a> 
                                  </div>
                                  {/* <div className={ this.state.Imgprofile ? "is-active" : "" }"profile-gallary-sub">
                               
                                  </div> */}
                                   <div className={ this.state.Imgprofile ? "profile-gallary-sub-avtice" : "profile-gallary-sub-none" }>
                                   {/* <p style={{textAlign:"center"}}>Company profile image</p> */}
                                   <div style={{position:"relative",left:"10px",top:"10px"}}>
                                      {
                                            ! this.state.shoeedit ? 
                                              <a href="#" class="button  is-primary " onClick={this.editShow} style={{textAlign:"center"}}> Add
                                                <div><i class="fas fa-camera" style={{marginLeft:"5px"}}></i></div>   
                                              </a>
                                              :
                                              <a href="#" class="button  is-danger " onClick={this.editClose} style={{textAlign:"center"}}>
                                                  <div>
                                                  <i class="fas fa-times"></i>
                                                </div>   
                                            </a>
                                        }

                                   </div>
                                     {
                                       !this.state.shoeedit ? 
                                       <div> 
                                   
                                           {
                                               this.state.ImgprofileIme?
                                                <div>  
                                                   {
                                          this.state.ImgprofileIme.length ===  0 ?
                                            <div>
                                         {
                                        this.props.organizer.company_images_url ? 
                                        <div class="profile-company-list-body">
                                        {
                                            this.props.organizer.company_images_url.length === 0 ?
                                                  <div>
                                                    
                                                  </div>
                                              :
                                                <ul className="profile-company-list">

                                                  {
                                                               this.props.organizer.company_images_url.map((data, i) => {
                                                                    return (
                                                                        <li key={i} >
                                                                             <Photo deletePhoto={this.deletePhoto } deletePhoto={this.deletePhoto }  photo={data} id={i}/>
                                                        
                                                                           
                                                        
                                                                        </li>



                                                                    )
                                                              })

                                                      }               
                                              
                                              </ul>
                                             }
                                            </div>
                                            :
                                            <div>
                                                
                                            </div>

                                          }

                                          </div>
                                          :
                                          <div class="profile-company-list-body">
                                             <ul className="profile-company-list">
                                             {
                                              this.state.ImgprofileIme.map((data, i) => {
                                                                return (
                                                                    <li key={i} >
                                                                           <Photo deletePhoto={this.deletePhoto } deletePhoto={this.deletePhoto }  photo={data} id={i}/>
                                                        
                                                    
                                                                    </li>
                                                                )
                                                          })

                                                } 
                                            </ul>    
                                          </div>
                                        }
                                                </div>
                                                :
                                                <div></div>
                                           }
                                      
                                      
                                      </div>
                                      :
                                      <div>
                                         <div className="profile-gallry-image">
                                            Add Photo Gallery
                                         </div>   

                                          <div className="profile-edit-image">
                                          
                                           
                                                <div> 
                                                {
                                                      this.state.ifImage?
                                                        <div>
                                                            {
                                                                    this.state.photos.map((url, i) => (
                                                                      <div  key={i} className="profile-image-edit">
                                                                          <img src={url} className=""
                                                                          alt="not available"/>
                                                                      </div>
                                                                    ))
                                                              }
                                                      
                                                          <ul class="social-buttons-list">
                                                              <li>
                                                              <button class="button btn-align btn-outlined info-btn" onClick={this.uploadImages}  style={{position:"relative",bottom:"9px"}}
                                                                    >Upload</button>
                                                              
                                                              </li>
                                                              <li>
                                                                   <div class = "file">
                                                                        <label class = "file-label">
                                                                        <input class = "file-input" type = "file" name="fileupload" onChange={this.selectImages} multiple/>
                                                                        <span class = "file-cta">
                                                                        <span class = "file-icon">
                                                                        <i class = "fas fa-upload"></i>
                                                                        </span>
                                                                        <span class = "file-label">
                                                                         Change 
                                                                        </span>
                                                                        </span>
                                                                        </label>
                                                                      </div>
                                                              </li>
                                                              
                                                            </ul>
                                                        
                                                            
                                                               
                                                        </div>
                                                        :
                                                        <div className="text-container-profile">
                                                           <div className="text-container-profile-sub">
                                                              <input type="file" 
                                                                      id="file" onChange={this.selectImages} multiple/>
                                                                      <label for="file" >
                                                                      <br/>
                                                                      <br/>
                                                                      <i class="fas fa-plus" style={{fontSize:"120%",textAlign:"center"}}></i> <br/>
                                                                        
                                                                </label>
                                                            </div>


                                                        
                                                        </div>
                                                    }
                                                         
                                         </div>
                              
                                    </div>
                                  </div>

                                      


                                     }
                                   


                                      
                                     
                                     
                                    </div>
                            </div>
                            <div className="profile-gallary-body">
                                  <div  className={ this.state.logoPro ? "profile-gallary-header-ative" : "profile-gallary-header" }>
                                   <a  onClick={this.profileLogo} >
                                      <p><b>Company Logo   <i class="fas fa-bullseye"></i></b></p> 
                                    </a>
                                  </div>
                                  <div  className={ this.state.logoPro ? "profile-gallary-sub-avtice" : "profile-gallary-sub-none" }>
                                  <div style={{position:"relative",left:"10px",top:"10px"}}>
                                            {
                                                  ! this.state.shoeedit ? 
                                                    <a href="#" class="button  is-primary " onClick={this.editShow} style={{textAlign:"center"}}> Add
                                                      <div><i class="fas fa-camera" style={{marginLeft:"5px"}}></i></div>   
                                                    </a>
                                                    :
                                                    <a href="#" class="button  is-danger " onClick={this.editClose} style={{textAlign:"center"}}>
                                                        <div>
                                                        <i class="fas fa-times"></i>
                                                      </div>   
                                                  </a>
                                              }

                                        </div>
                                        {
                                        
                                          !this.state.shoeedit ?
                                           <div> 
                                             <br/>
                                            <div className="profile-file-logo">
                                              <div class="card ressource-card">
                                                      <div class="card-image" style={{paddingTop: "5px"}}>
                                                        {
                                                            this.state.logoProImg  === ""?
                                                          <figure class="image is-4by3 zoomOut" >
                                                              <img src={this.props.organizer.logo_url} alt=""/>
                                                            </figure>
                                                            :
                                                            <figure class="image is-4by3 zoomOut" >
                                                              <img src={  this.state.logoProImg} alt=""/>
                                                            </figure>
                                                        }
                                                          
                                                        </div>
                                                        <div class="card-content">
                                                            <div class="media">
                                                                <div class="media-content"style={{textAlign:"center"}}>
                                                                {/* {
                                                                    ! this.state.shoeedit ? 
                                                                    <a href="#" class="button  is-primary " onClick={this.editShow}>  <i class="far fa-images"></i> </a>
                                                                    :
                                                                    <a href="#" class="button  is-danger " onClick={this.editClose}>
                                                                        <div>
                                                                        <i class="fas fa-times"></i>
                                                                      </div>   
                                                                      </a>
                                                                  } */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                   </div>
                                                   <br/>

                                               </div>
                                             </div>
                                            :
                                            <div>
                                              <div className="profile-gallry-image">
                                                  Add Photo Gallery
                                              </div>   

                                                <div className="profile-edit-image">
                                                  <div> 
                                                      {
                                                            this.state.ifImage?
                                                              <div>
                                                                  {
                                                                          this.state.photos.map((url, i) => (
                                                                            <div  key={i} className="profile-image-edit">
                                                                                <img src={url} className=""
                                                                                alt="not available"/>
                                                                            </div>
                                                                          ))
                                                                    }
                                                            
                                                                <ul class="social-buttons-list">
                                                                    <li>
                                                                    <button class="button btn-align btn-outlined info-btn" onClick={this.uploadImages}  style={{position:"relative",bottom:"9px"}}
                                                                          >Upload</button>
                                                                    
                                                                    </li>
                                                                    <li>
                                                                        <div class = "file">
                                                                              <label class = "file-label">
                                                                              <input class = "file-input" type = "file" name="fileupload" onChange={this.selectImages} multiple/>
                                                                              <span class = "file-cta">
                                                                              <span class = "file-icon">
                                                                              <i class = "fas fa-upload"></i>
                                                                              </span>
                                                                              <span class = "file-label">
                                                                              Change 
                                                                              </span>
                                                                              </span>
                                                                              </label>
                                                                            </div>
                                                                    </li>
                                                                    
                                                                  </ul>
                                                              
                                                                  
                                                                    
                                                              </div>
                                                              :
                                                              <div className="text-container-profile">
                                                                <div className="text-container-profile-sub">
                                                                    <input type="file" 
                                                                            id="file" onChange={this.selectImages} multiple/>
                                                                            <label for="file" >
                                                                            <br/>
                                                                            <br/>
                                                                            <i class="fas fa-plus" style={{fontSize:"120%",textAlign:"center"}}></i> <br/>
                                                                              
                                                                      </label>
                                                                  </div>


                                                              
                                                              </div>
                                                          }
                                                              
                                              </div>
                                    
                                          </div>
                                        </div>
                                        }
                                  
                                    </div>
                                      
                            </div>

                            <div className="profile-gallary-body">
                                  <div  className={ this.state.certificat ? "profile-gallary-header-ative" : "profile-gallary-header" }>
                                  <a onClick={this.certifications}> <p><b>Company  Certifications  <i class="fas fa-certificate"></i></b></p> </a>
                                  </div>
                                  <div  className={ this.state.certificat?"profile-gallary-sub-avtice" : "profile-gallary-sub-none" }>
                                    <div style={{position:"relative",left:"10px",top:"10px"}}>
                                            {
                                                  ! this.state.shoeedit ? 
                                                    <a href="#" class="button  is-primary " onClick={this.editShow} style={{textAlign:"center"}}> Add
                                                      <div><i class="fas fa-camera" style={{marginLeft:"5px"}}></i></div>   
                                                    </a>
                                                    :
                                                    <a href="#" class="button  is-danger " onClick={this.editClose} style={{textAlign:"center"}}>
                                                        <div>
                                                        <i class="fas fa-times"></i>
                                                      </div>   
                                                  </a>
                                              }

                                        </div>
                                        <div>
                                        {
                                        
                                        !this.state.shoeedit ?
                                         <div>
                                         {
                                            this.state.certificatImg?
                                              <div>
                                              {
                                                this.state.certificatImg.length === 0 ?
                                                <div>
                                                  {
                                                this.props.organizer.certifications_images_url ? 
                                                      <div class="profile-company-list-body">
                                                          {
                                                                this.props.organizer.certifications_images_url.length === 0 ?
                                                                      <div>
                                                                        
                                                                      </div>
                                                                  :
                                                                    <ul className="profile-company-list">

                                                                      {
                                                                        this.props.organizer.certifications_images_url.map((data, i) => {
                                                                              return (
                                                                                  <li key={i} >
                                                                                    <Photo deletePhoto={this.deletePhoto } deletePhoto={this.deletePhoto }  photo={data} id={i}/>
          
                                                                                  </li>
                                                                                        )
                                                                                  })

                                                                          }               
                                                                  
                                                                  </ul>
                                                          }
                                                        </div>
                                                        :
                                                        <div></div>

                                                  }
                                                        </div>
                                                        :
                                                        <div>
                                                            <div class="profile-company-list-body">
                                                            <ul className="profile-company-list">
                                                            {
                                                                        this.state.certificatImg.map((data, i) => {
                                                                              return (
                                                                                  <li key={i} >
                                                                                        <div class="card ressource-card">
                                                                                            <div class="card-image" style={{paddingTop: "5px"}}>
                                                                                                <figure class="image is-4by3 zoomOut" >
                                                                                                    <img src={data} alt=""/>
                                                                                                </figure>
                                                                                            </div>
                                                                                            <div class="card-content">
                                                                                                <div class="media">
                                                                                                <div class="media-content"style={{textAlign:"center"}}>
                                                                                                    {
                                                                                                        ! this.state.shoeedit ? 
                                                                                                        <a href="#" class="button  is-primary " onClick={this.editShow}>  <i class="far fa-images"></i> </a>
                                                                                                        :
                                                                                                        <a href="#" class="button  is-danger " onClick={this.editClose}>
                                                                                                            <div>
                                                                                                            <i class="fas fa-times"></i>
                                                                                                          </div>   
                                                                                                          </a>
                                                                                                      }
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                  
                                                                                  </li>
                                                                                        )
                                                                                  })

                                                                          }
                                                                  </ul>       
                                                            </div>  
                                                        </div>
                                                    }
                                              </div>
                                            :
                                              <div></div>  
                                         }
                                       
                                          </div>
                                        :
                                        <div>
                                          <div className="profile-gallry-image">
                                            Add Photo Gallery
                                          </div>   

                                          <div className="profile-edit-image">
                                          
                                            
                                                <div> 
                                                {
                                                      this.state.ifImage?
                                                        <div>
                                                            {
                                                                    this.state.photos.map((url, i) => (
                                                                      <div  key={i} className="profile-image-edit">
                                                                          <img src={url} className=""
                                                                          alt="not available"/>
                                                                      </div>
                                                                    ))
                                                              }
                                                      
                                                          <ul class="social-buttons-list">
                                                              <li>
                                                              <button class="button btn-align btn-outlined info-btn" onClick={this.uploadImages}  style={{position:"relative",bottom:"9px"}}
                                                                    >Upload</button>
                                                              
                                                              </li>
                                                              <li>
                                                                    <div class = "file">
                                                                        <label class = "file-label">
                                                                        <input class = "file-input" type = "file" name="fileupload" onChange={this.selectImages} multiple/>
                                                                        <span class = "file-cta">
                                                                        <span class = "file-icon">
                                                                        <i class = "fas fa-upload"></i>
                                                                        </span>
                                                                        <span class = "file-label">
                                                                          Change 
                                                                        </span>
                                                                        </span>
                                                                        </label>
                                                                      </div>
                                                              </li>
                                                              
                                                            </ul>
                                                        
                                                            
                                                                
                                                        </div>
                                                        :
                                                        <div className="text-container-profile">
                                                            <div className="text-container-profile-sub">
                                                              <input type="file" 
                                                                      id="file" onChange={this.selectImages} multiple/>
                                                                      <label for="file" >
                                                                      <br/>
                                                                      <br/>
                                                                      <i class="fas fa-plus" style={{fontSize:"120%",textAlign:"center"}}></i> <br/>
                                                                        
                                                                </label>
                                                            </div>


                                                        
                                                        </div>
                                                    }
                                                          
                                          </div>
                              
                                    </div>
                                  </div>
                                        }
                                        </div>
                                       
                                       
                            
                                  </div>
                            </div>
                            
                            <div className="profile-comapny-setting-sub">
                              <div class="">
                                <div className="">
                                   <div className="info-body-head" style={{textAlign:"left"}}>
                                       <p>Edit company profile</p> 
                                       <hr/>
                                   </div>
                                <form onSubmit={this.upDate_data}>
                                   <div class="columns">
                                     <div class="column is-one-third">Company Name:</div>
                                     <div class="column">
                                         <div class="control">
                                             <input class="input is-small" type="text" 
                                             ref={ input => this.name = input } defaultValue={this.props.organizer.official_name}
                                             onChange={this.handlefullnameChange }
                                             placeholder="Company Name"/>
                                           </div>
                                         </div>
                                     </div>

                                     <div class="columns">
                                      <div class="column is-one-third"> Company Email  </div>
                                      <div class="column">
                                          <div class="control">
                                              <input class="input is-small" type="text" 
                                                ref={ input => this.email = input }
                                                defaultValue={this.props.organizer.business_email}
                                              placeholder="Company email" required/>
                                            </div>
                                          </div>
                                      </div>

                           
                                      
                                      <div class="columns">
                                        <div class="column is-one-third">  Company  Phone </div>
                                        <div class="column">
                                            <div class="control">
                                                <input class="input is-small" type="text" 
                                                  ref={ input => this.business_mobile = input }
                                                  defaultValue={this.props.organizer.business_mobile}
                                                placeholder="Company phone" required/>
                                              </div>
                                            </div>
                                        </div>
 
                                     <div class="columns">
                                     <div class="column is-one-third">State</div>
                                     <div class="column">
                                         <div class="control">
                                             <input class="input is-small" type="text" 
                                             ref={ input => this.state1 = input }
                                             defaultValue={this.props.organizer.location_state}
                                             placeholder="State"/>
                                           </div>
                                         </div>
                                     </div>
 
                                     <div class="columns">
                                     <div class="column is-one-third">City</div>
                                     <div class="column">
                                         <div class="control">
                                             <input class="input is-small" type="text" 
                                             ref={ input => this.city = input }
                                             defaultValue={this.props.organizer.location_city}
                                             placeholder="City"/>
                                           </div>
                                         </div>
                                     </div>
 
 
                                     <div class="columns">
                                     <div class="column is-one-third">Company  Address</div>
                                     <div class="column">
                                         <div class="control">
                                             <input class="input is-small" type="text" 
                                               ref={ input => this.address = input }
                                               defaultValue={this.props.organizer.address}
                                             placeholder="Company Operational Address"/>
                                           </div>
                                         </div>
                                     </div>

                                     
 
 
                                     {/* <div class="columns">
                                     <div class="column is-one-third">Business type:</div>
                                     <div class="column">
                                       <div class="field">
                                         <div class="control">
                                           <div class="select is-small">
                                             <select onChange={this.selectChangeC}  class="form-control" value={this.state.selectC}>
                                                           <option value={this.state.selectC}>{this.state.selectC}</option>
                                                       {
                                                           this.state.type.map(data  => {
                                                               return  <option  key={data} value={data}>{data}</option>
                                                           })
                                                       }
                                                       
                                                                   
                                             </select>
                                           </div>
                                         </div>
                                       </div>
                                       </div>
                                     </div> */}
 
                                     
 
 
                                     <div class="columns">
                                     <div class="column is-one-third">Main products </div>
                                     <div class="column">
                                         <div class="control">
                                             <input class="input is-small" type="text" 
                                               ref={ input => this.mainproduct = input }
                                               defaultValue={this.props.organizer.main_products}
                                             placeholder="Main products"/>
                                           </div>
                                         </div>
                                     </div>
 
 
                                     
                                     <div class="columns">
                                     <div class="column is-one-third">  Established </div>
                                     <div class="column">
                                         <div class="control">
                                             <input class="input is-small" type="text" 
                                               ref={ input => this.established = input }
                                               defaultValue={this.props.organizer.established}
                                             placeholder="Year  Established"/>
                                           </div>
                                         </div>
                                     </div>
 
 
                                    
                                    {
                                       this.props.organizer.total_employees ?
                                          <div class="columns">
                                          <div class="column is-one-third">Total No. Employees: {this.props.organizer.total_employees}</div>
                                          <div class="column">
                                          
                                              <div class="field">
                                              <div class="control">
                                                <div class="select is-small">
                                                  <select onChange={this.selectChange}  class="form-control" value={this.state.select}>
                                                                <option value={this.props.organizer.total_employees}>{this.props.organizer.total_employees}</option>
                                                            {
                                                                this.state.Employees.map(data  => {
                                                                    return  <option  key={data} value={data}>{data}</option>
                                                                })
                                                            }
                                                            
                                                                        
                                                  </select>
                                                  {/* <select>
                                                    <option value="">--- Please select ---</option>
                                                    <option>With options</option>
                                                  </select> */}
                                                </div>
                                              </div>
                                            </div>
                                          
                                            </div>
                                          </div>
                                       :
                                       <div></div>
                                       }   
 
                                    

 
                                    {
                                      this.state.organizer.description?
                                      <div class="columns">
                                     <div class="column is-one-third">Company Description:</div>
                                     <div class="column">
                                         <div class="control">
                                         <textarea class="textarea" ref={input => this.description = input}
                                           defaultValue={this.state.organizer.description}
                                          placeholder="Company Description "></textarea>
                                           </div>
                                         </div>
                                     </div>
                                     :
                                     <div></div>
                                    }
                                    
                                  
 
                                     {/* <button onClick={this.clickeme}>click</button> */}
 
                                     <div className="info-payment-button">
                                     <button  class="button is-primary is-rounded" >Submit</button>
                                     </div>
                                     </form>    
                                   </div>
                     
                                    
                                    
                                 </div>
                             </div>

                            
                           
                              

                        </div>
                     </div>
                   </div> 
                </div>
            )
        }
    }    
  export default  Profile ;      




  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", position:"absolute",height:"30px",  }}
        onClick={onClick}
      />
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block",  position:"absolute",height:"30px",  }}
        onClick={onClick}
      />
    );
  }


// WEBPACK FOOTER //
// ./src/component/company/profile.js